// extracted by mini-css-extract-plugin
module.exports = {"iframeWrapper":"iframeEmbed-module--iframeWrapper--oDe_u","narrower":"iframeEmbed-module--narrower--3GO_B","iframe":"iframeEmbed-module--iframe--3GRJp"};